import { Checkbox, IModalAction, Input, TModalCustomView } from '@ws/shared/components';
import { ChangeEvent, useEffect, useRef, useState } from 'react';

import { isMobile } from '../../../modules/getResolution';
import { getNowAndAName } from '../../../utils/getNowAndAName';
import { transliterate } from '../../../utils/transliterate';
import { ICreateProjectParams } from '../types';

const modalTitle = 'Создаём новый проект';
const modalMessage = 'Введите имя';

export function showProjectCreationModal({
  isAuthed,
  createProject,
  createProjectAndGo,
  resolution,
  initialName,
}: {
  isAuthed: boolean;
  createProject: (params: ICreateProjectParams) => void;
  createProjectAndGo: (params: ICreateProjectParams) => void;
  resolution: string;
  initialName?: string;
}): TModalCustomView {
  return function ProjectCreationModal({
    closeAllModals,
    onAwayClose,
    components: {
      ModalWrapper,
      ModalContentWrapper,
      ModalCloseButton,
      ModalTitle,
      ModalSubTitle,
      ModalContent,
      ButtonsPanel,
    },
  }) {
    const inputRef = useRef<HTMLInputElement>(null);

    const { now } = getNowAndAName();
    const [name, setName] = useState(initialName ?? `Твой новый проект ${now}`);
    const [slug, setSlug] = useState(transliterate(name));
    const [isWithSync, setIsWithSync] = useState(isAuthed);
    const mobile = isMobile(resolution);
    const baseButtons: IModalAction[] = [
      {
        text: 'Сохранить',
        color: 'secondary',
        onClick: () => {
          createProject({ name, slug, isWithSync });
          closeAllModals();
        },
      },
      {
        text: 'Сохранить и перейти',
        onClick: () => {
          createProjectAndGo({ name, slug, isWithSync });
          closeAllModals();
        },
      },
    ];
    const isNotMobileButtons: IModalAction[] = mobile
      ? []
      : [{ text: 'Отмена', color: 'tertiary', onClick: closeAllModals }];

    function handleInputOnChange(event: ChangeEvent<HTMLInputElement>) {
      const newName = event.target.value;
      const newSlug = transliterate(newName);

      setName(newName);
      setSlug(newSlug);
    }

    useEffect(() => {
      inputRef.current?.select();
    }, []);

    return (
      <ModalWrapper onClick={onAwayClose}>
        <ModalContentWrapper>
          <ModalCloseButton onClose={closeAllModals} />
          <ModalTitle>{modalTitle}</ModalTitle>
          <ModalSubTitle>{modalMessage}</ModalSubTitle>
          <ModalContent>
            <Input ref={inputRef} value={name} onChange={handleInputOnChange} />
            <div style={{ height: '4px' }} />
            <div style={{ opacity: isAuthed ? 1 : 0.5 }}>
              <Checkbox
                disabled={!isAuthed}
                value={isWithSync}
                onChange={() => setIsWithSync(!isWithSync)}
              >
                С синхронизацей
              </Checkbox>
            </div>
            {!isAuthed && (
              <span style={{ fontSize: 12 }}>
                <i>Синхронизация доступно только после авторизации</i>
              </span>
            )}
          </ModalContent>

          <ButtonsPanel actions={[...isNotMobileButtons, ...baseButtons]} />
        </ModalContentWrapper>
      </ModalWrapper>
    );
  };
}
